import { Link } from "react-router-dom";
import React from "react";

const MenuNavLink = (props) => {
  return <Link exact="true" {...props} style={{ textDecoration: "none" }} />;
};

export default MenuNavLink;
